import { textColumn } from '@/shared/grids/columns/textColumn';
import { GridColumnSettings } from '@/shared/types/grid';

export const notesExcerptColumn = <T>(options: {
  uid?: string;
  field: keyof T & string;
  chooserName?: string;
}): GridColumnSettings<T> => {
  const { uid, field, chooserName } = options;

  return textColumn({
    uid,
    field,
    header: 'Notes (First Line)',
    template: `\${if(notesExcerpt)}\${notesExcerpt}\${else}<span class="text-more-muted">No notes</span>\${/if}`,
    width: 200,
    visible: false,
    chooserName,
  });
};
